"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    arenas: function() {
        return _arenas.arenas;
    },
    brands: function() {
        return _brands.brands;
    },
    championships: function() {
        return _championships.championships;
    },
    defaultArenaConfig: function() {
        return _arenas.defaultArenaConfig;
    },
    factions: function() {
        return _factions.factions;
    },
    feuds: function() {
        return _feuds.feuds;
    },
    getCollectionByBrand: function() {
        return getCollectionByBrand;
    },
    reigns: function() {
        return _reigns.reigns;
    },
    shows: function() {
        return _shows.shows;
    },
    wrestlers: function() {
        return _wrestlers.default;
    }
});
const _arenas = require("./arenas");
const _brands = require("./brands");
const _shows = require("./shows");
const _feuds = require("./feuds");
const _factions = require("./factions");
const _championships = require("./championships");
const _reigns = require("./reigns");
const _ppvs = require("./ppvs");
const _wrestlers = /*#__PURE__*/ _interop_require_default(require("./wrestlers"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const collectionIncludes = (collection, id)=>{
    return collection.filter((item)=>item?.brandIds?.includes(id));
};
function getCollectionByBrand(brandId) {
    const filteredProductions = _ppvs.productions.filter((item)=>item?.brandIds?.includes(brandId));
    const segmentIds = filteredProductions.reduce((acc, item)=>[
            ...acc,
            ...item.segmentIds
        ], []);
    const filteredSegments = _ppvs.segments.filter((item)=>segmentIds.includes(item.id));
    const filteredAppearances = _ppvs.appearances.filter((item)=>segmentIds.includes(item.segmentId));
    const filteredChampionships = _championships.championships.filter((item)=>item?.brandIds?.includes(brandId));
    const championshipIds = filteredChampionships.map((item)=>item.id);
    const filteredReigns = _reigns.reigns.filter((item)=>championshipIds.includes(item.championshipId));
    return {
        arenas: _arenas.arenas,
        brands: _brands.brands.filter((item)=>item.id === brandId),
        championships: filteredChampionships,
        appearances: filteredAppearances,
        reigns: filteredReigns,
        segments: filteredSegments,
        productions: filteredProductions,
        factions: collectionIncludes(_factions.factions, brandId),
        feuds: collectionIncludes(_feuds.feuds, brandId),
        shows: collectionIncludes(_shows.shows, brandId),
        wrestlers: collectionIncludes(_wrestlers.default, brandId)
    };
}
